<template>
  <div
    class="h5-price-filter"
    :class="{
      'h5-price-filter--active': priceStart != null || priceEnd != null
    }"
    @click="show = true"
  >
    Price Range
    <Icon name="arrow-down-l-2" />

    <FilterDialog
      v-model:show="show"
      title="Price Range"
      @reset="onReset"
      @submit="onSubmit"
    >
      <div
        class="h5-price-filter-range"
      >
        <input
          v-model="price.min"
          :placeholder="`Low (${currency.current.targetCurrency} ${currency.current.targetUnit})`"
          type="number"
        > to
        <input
          v-model="price.max"
          :placeholder="`High (${currency.current.targetCurrency} ${currency.current.targetUnit})`"
          type="number"
        >
      </div>
    </FilterDialog>
  </div>
</template>

<script setup>
import { Icon } from '@/components/Icon'
import FilterDialog from './FilterDialog.vue'
import { useCurrencyStore } from '@/pinia/currency'

const show = ref(false)

const emit = defineEmits(['submit'])

const currency = useCurrencyStore()

const priceStart = defineModel('priceStart', { type: Number, default: null })

const priceEnd = defineModel('priceEnd', { type: Number, default: null })

const price = reactive({ min: priceStart.value, max: priceEnd.value })

watch(() => [priceStart.value, priceEnd.value], ([min, max]) => {
  price.min = min
  price.max = max
})

const onReset = () => {
  show.value = false
  priceStart.value = null
  priceEnd.value = null
  emit('submit')
}

const onSubmit = () => {
  show.value = false
  priceStart.value = price.min
  priceEnd.value = price.max
  emit('submit')
}
</script>

<style lang="less">
.h5-price-filter {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  height: 36px;
  background-color: #f5f5f5;
  border-radius: 20px;
  font-size: 12px;
  font-family: mon-600;
  color: #232323;

  &--active {
    background-color: #232323;
    color: white;
  }

  &-range {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #232323;
    font-size: 12px;
    font-family: mon-500;

    input {
      text-align: center;
      height: 36px;
      line-height: 36px;
      width: 50%;
      border: 1px solid #EBF1F5;
      outline: none;
      border-radius: 4px;
      font-size: 12px;
      font-family: mon-500;
      transition: all .2s ease-in-out;
      &:focus {
        border: 1.5px solid #232323;
        background-color: #F8F8F8;
      }
      &::placeholder {
        color: #b2b7c2;
      }
    }
  }
}
</style>
